<template>
	<div v-if="isSelected" class="accessory-item">
		<div class="accessory-item-content">
			<div class="accessory-item-image">
				<img :src="currentVariantImage" alt="">
			</div>
			<div class="accessory-item-text">
				<h5 class="accessory-item-name">
					{{ accessory.name }}
				</h5>
				<p v-if="isDifferentColors" class="accessory-item-color">
					{{ currentVariantColor }}
				</p>
			</div>
		</div>
		<div class="accessory-item-actions">
			<div class="accessory-item-multiselect">
				<multiselect
					v-if="type === 'storage' && storageOptions"
					:class="{ 'disable-element': isCartUpdating }"
					:disabled="isCartUpdating"
					v-model="storage"
					:allow-empty="false"
					:custom-label="storageName"
					:options="storageOptions"
					:searchable="false"
					:show-labels="false"
					@input="selectStorage(storage.id)"
				/>
				<multiselect
					v-if="showMultiselect && type !== 'storage'"
					:class="{ 'disable-element': isCartUpdating }"
					:disabled="isCartUpdating"
					v-model="quantity"
					:allow-empty="false"
					:options="[1, 2, 3]"
					:searchable="false"
					:show-labels="false"
					@input="isSelected && update(currentVariantId)"
				/>
			</div>
			<div class="accessory-item-delete">
				<img
					src="/images/icons/cart-icons/trash.svg"
					title="Remove Accessory"
					alt="Remove Accessory"
					@click="remove"
				>
			</div>
			<p class="accessory-item-price">
				{{ currentVariantPrice | formatMoney }}
			</p>
		</div>
	</div>
</template>

<script>
import AccessoryFunctionalities from "../mixins/accessoryFunctionalities";

export default {
	name: "AccessoryItem",
	mixins: [AccessoryFunctionalities]
};
</script>

<style lang="scss" scoped>
.accessory-item {
	border-bottom: 1px solid #dadde0;
	padding: 40px 42px 40px 41px;
	display: flex;
	justify-content: space-between;
	align-items: flex-start;

	@media (min-width: 320px) and (max-width: 580px) {
		padding: 23px 0 16px 10px;
		flex-direction: column;
	}

	&-content {
		display: flex;
	}

	&-image {
		width: 96px;
		height: 96px;
		margin-right: 18px;

		@media (min-width: 320px) and (max-width: 580px) {
			flex-shrink: 0;
		}

		img {
			width: 100%;
		}
	}

	&-name,
	&-price {
		color: #141226;
		font-weight: bold;
	}

	&-name {
		margin-bottom: 4px;
		font-size: 16px;

		@media (min-width: 320px) and (max-width: 580px) {
			margin-top: 0;
		}
	}

	&-actions {
		display: flex;
		align-items: center;

		@media (min-width: 320px) and (max-width: 580px) {
			margin-top: -25px;
			width: 100%;
			justify-content: flex-end;
		}

		select {
			width: 56px;
			height: 36px;
			background: transparent;
			border-radius: 3px;
			padding: 7px;
			cursor: pointer;
		}
	}

	&-price {
		font-size: 16px;
		width: 60px;
		margin: 0;
	}

	&-delete {
		margin: 0 80px 0 18px;
		width: 22px;
		height: 24px;
		cursor: pointer;

		@media (min-width: 320px) and (max-width: 580px) {
			margin: 0px 35px 0 15px;
		}
	}

	&-blank {
		width: 56px;
		height: 36px;
	}
}

hr {
	border-top: 1px solid #dadde0;
}

@media only screen and (max-device-width: 480px) {
	.included {
		align-self: flex-end;

		&__text {
			color: #141226;
			font-weight: bold;
			width: 100%;
		}
	}
}
</style>

<style lang="scss">
@import "~@s/_asset-mixers.scss";

.accessory-item {
	.multiselect {
		width: auto;
		height: 36px;

		@media (min-width: 320px) and (max-width: 580px) {
			font-size: 14px;
		}

		&__select {
			@media (min-width: 320px) and (max-width: 580px) {
				height: 36px;
			}
		}

		&__option--highlight {
			background: $purple;
			outline: none;
			color: #fff;
		}
		&__option--selected {
			&.multiselect__option--highlight {
				background: #f3f3f3;
				color: #35495e;
				cursor: default;
			}
		}
	}
}
</style>
